import React from "react";

const ProductCardSmallShimmer = () => {
  return (
    <>
      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -450px 0;
            }
            100% {
              background-position: 450px 0;
            }
          }

          .shimmer {
            background: linear-gradient(
              90deg,
              #e5e7eb 25%,
              #f3f4f6 37%,
              #e5e7eb 63%
            );
            background-size: 400px 100%;
            animation: shimmer 1.4s infinite linear;
          }
        `}
      </style>

      <div className="bg-white rounded-2xl border p-3 ">
        <div className="w-full h-40 rounded-lg shimmer" />

        <div className="mt-3 space-y-2">
          <div className="h-4 w-3/4 rounded shimmer" />
          <div className="h-4 w-1/2 rounded shimmer" />

          <div className="flex justify-between items-center mt-3">
            <div className="space-y-2">
              <div className="h-5 w-20 rounded shimmer" />
              <div className="h-3 w-14 rounded shimmer" />
            </div>

            <div className="h-9 w-20 rounded-lg shimmer" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductCardSmallShimmer;
